<template>
	<div>
		<notifications></notifications>
		<div :class="{'nav-open': $sidebar.showSidebar}">
			<router-view v-if="$store.state.authentication.loggedIn && $store.state.authentication.checked"></router-view>
			<!-- <login v-if="!$store.state.authentication.loggedIn"></login> -->
			<auth v-if="!$store.state.authentication.checked || $store.state.authentication.expired"></auth>
		</div>
	</div>
</template>

<script>
	import Login from '@/pages/Login.vue'
	import Auth from '@/pages/Auth.vue'
	export default {
		components: {
			Login,
			Auth
		},
		data() {
			return {
				default: null
			}
		},
		created() {
			window.document.title = this.translate(this.locale.headTitle);
		}
	}
</script>
<style>
	@media (min-width: 992px) {
		.show-web {
			display: inline;
		}
		.show-mobile {
			display: none;
		}
	}
	@media (max-width: 991px) {
		.show-web {
			display: none;
		}
		.show-mobile {
			display: inline;
		}
	}

	.text-primary {
        color: #353690 !important;
    }
	.vs__dropdown-menu {
        margin-top: 3px !important;
        border: 2px solid #EEE !important;
        border-radius: 6px !important;
        padding: 0 !important;
    }
    .vs__dropdown-option {
        padding: 8px 20px !important;
    }
	.vs__actions {
		display: none !important;
	}
    .vs--open {
        border: 2px solid #353690 !important;
    }

    .vs__selected {
        font-family: "Open Sans", "Hanuman", sans-serif !important;
    }
	.vs__dropdown-option--highlight, .vs__dropdown-option--selected {
		color: #FFF !important;
		background-color: #353690 !important;
	}

    .vs__dropdown-toggle {
        margin-top: 3px !important;
        margin-bottom: 24px !important;
		border: 0 !important;
    }

	.md-title {
		letter-spacing: 0 !important;
	}

	.green {
		background-color: #1aa348;
		color: #FFF;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.neutral {
		background-color: #c189ee;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.late {
		background-color: #fab1a0;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.error {
		background-color: #f35734;
		border-radius: 5px;
		padding: 4px 8px;
	}
	.gray {
		background-color: #bfbfbf;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.warn {
		background-color: #f39c12;
		border-radius: 5px;
		padding: 4px 8px;
	}
	.blue {
		background-color: #80e6ff;
		border-radius: 5px;
		margin-top: 5px;
		padding: 4px 8px;
	}

	.return {
		background-color: #fd79a8;
		border-radius: 5px;
		padding: 4px 8px;
	}

	.vdatetime-input {
		width: 100% !important;
		height: 38px !important;
		padding: 4px 12px !important;
        border: 2px solid #EEE !important;
        border-radius: 6px !important;
        font-family: "Open Sans", "Hanuman", sans-serif !important;
	}

	.md-list-item-text {
		display: flex !important;
		justify-content: center !important;
		padding: 0 15px !important;
		font-family: "Open Sans", "Hanuman", sans-serif !important;
		/* color:#1aa348; */
	}
	.md-selected {
		color:#1aa348 !important;
	}

	.vdatetime {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue